import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { formatMoney, formatNumber, formatPercent } from "./Utils";

export default function CensusData(props) {
  const censusData = props.estatedProperty.census_data_by_zip_code;
  const censusDataState = props.estatedProperty.census_data_by_state;
  const censusDataNation = props.estatedProperty.census_data_by_nation;

  let monthlyRent;
  let _33Income;
  if (props.estatedProperty.property_info) {
    monthlyRent = props.estatedProperty.property_info.estimated_rent;
    _33Income = censusData.mean_household_income / 3;
  }

  let rentToHHIncomeRatio;
  if (monthlyRent && censusData.mean_household_income) {
    rentToHHIncomeRatio = (monthlyRent * 12) / censusData.mean_household_income;
  }

  let marketRent;
  let marketRentToHHIncomeRatio;
  const estimatedRentPerSqft =
    props.estatedProperty.scraper?.estimated_rent_per_sqft || [];
  if (estimatedRentPerSqft.length) {
    const estimatedRentPerSqftValue = estimatedRentPerSqft[0].value;
    const bedsCount = props.estatedProperty.property_info.bed;
    const marketRentPerSqft = estimatedRentPerSqftValue[bedsCount]
      ? estimatedRentPerSqftValue[bedsCount]
      : estimatedRentPerSqftValue.all;
    if (marketRentPerSqft) {
      marketRent =
        marketRentPerSqft.median * props.estatedProperty.property_info.sqft;
      marketRentToHHIncomeRatio =
        (marketRent * 12) / censusData.mean_household_income;
    }
  }

  const formatOneDelta = (val, method) =>
    `${(val < 0 ? "" : "+") + method(val)}`;
  const formatDelta = (key) => {
    const state = `${formatOneDelta(
      (censusData[key] - censusDataState[key]) / censusDataState[key],
      formatPercent
    )}`;
    const nation = `${formatOneDelta(
      (censusData[key] - censusDataNation[key]) / censusDataNation[key],
      formatPercent
    )}`;
    const stateEl = (
      <span
        style={{
          color: censusData[key] - censusDataState[key] < 0 ? "red" : "green",
        }}
      >
        {state} State
      </span>
    );
    const nationalEl = (
      <span
        style={{
          color: censusData[key] - censusDataNation[key] < 0 ? "red" : "green",
        }}
      >
        {nation} National
      </span>
    );
    return (
      <span>
        ({stateEl}, {nationalEl})
      </span>
    );
  };
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Typography variant="h6" color="primary" gutterBottom>
        Census Data by Zip Code
      </Typography>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>Median Rent</TableCell>
            <TableCell>
              {censusData.median_rent
                ? formatMoney(censusData.median_rent)
                : ""}
            </TableCell>
            <TableCell>
              {censusData.median_rent ? formatDelta("median_rent") : ""}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Median Household Income</TableCell>
            <TableCell>
              {censusData.median_household_income
                ? formatMoney(censusData.median_household_income)
                : ""}
            </TableCell>
            <TableCell>
              {censusData.median_household_income
                ? formatDelta("median_household_income")
                : ""}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Mean Household Income</TableCell>
            <TableCell>
              {censusData.mean_household_income
                ? formatMoney(censusData.mean_household_income)
                : ""}
            </TableCell>
            <TableCell>
              {censusData.mean_household_income
                ? formatDelta("mean_household_income")
                : ""}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Estimated Annual Rent / 33% x Mean Household Income
            </TableCell>
            <TableCell>
              {monthlyRent
                ? `${formatMoney(monthlyRent * 12)} / ${formatMoney(_33Income)}`
                : ""}
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Rent to Mean Household Income Ratio</TableCell>
            <TableCell>
              {rentToHHIncomeRatio ? formatNumber(rentToHHIncomeRatio) : ""}
            </TableCell>
            <TableCell>
              {rentToHHIncomeRatio ? (
                <span>
                  {formatMoney(
                    censusData.mean_household_income - monthlyRent * 12
                  )}{" "}
                  after rent /{" "}
                  {formatPercent(
                    (monthlyRent * 12) / censusData.mean_household_income
                  )}
                </span>
              ) : (
                ""
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Market Rent to Mean Household Income Ratio</TableCell>
            <TableCell>
              {marketRentToHHIncomeRatio
                ? formatNumber(marketRentToHHIncomeRatio)
                : ""}
            </TableCell>
            <TableCell>
              {marketRentToHHIncomeRatio ? (
                <span>
                  {formatMoney(
                    censusData.mean_household_income - marketRent * 12
                  )}{" "}
                  after rent /{" "}
                  {formatPercent(
                    (marketRent * 12) / censusData.mean_household_income
                  )}
                </span>
              ) : (
                ""
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Estimated Rent to Market Rent Ratio</TableCell>
            <TableCell>
              {marketRent && monthlyRent
                ? formatNumber(monthlyRent / marketRent)
                : ""}
            </TableCell>
            <TableCell>
              {marketRent && monthlyRent ? (
                <span
                  style={{
                    color: monthlyRent - marketRent < 0 ? "red" : "green",
                  }}
                >
                  {formatOneDelta(monthlyRent - marketRent, formatMoney)} /{" "}
                  {formatOneDelta(monthlyRent / marketRent - 1, formatPercent)}
                </span>
              ) : (
                ""
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
}
